/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    a: "a",
    div: "div",
    p: "p",
    strong: "strong",
    ul: "ul",
    li: "li",
    img: "img",
    h2: "h2",
    h3: "h3"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h1, {
    id: "about-the-data-science-editor-for-excel",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#about-the-data-science-editor-for-excel",
    "aria-label": "about the data science editor for excel permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "About the Data Science Editor for Excel"), "\n", React.createElement(_components.p, null, "The ", React.createElement(_components.strong, null, "Data Science Editor for Excel"), " is an experimental structured editor to create data analysis programs\nin Excel Web."), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(_components.strong, null, React.createElement(_components.a, {
    href: "https://appsource.microsoft.com/en-us/product/office/WA200005186",
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "Get It Now"))), "\n"), "\n", React.createElement(_components.p, null, React.createElement(_components.img, {
    src: "/data-science-editor/static/hero-d2f838a97b1dec217fc702e4b36978be.png",
    alt: "A data analysis program"
  })), "\n", React.createElement(_components.h2, {
    id: "getting-started",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#getting-started",
    "aria-label": "getting started permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Getting started"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "Download the ", React.createElement(_components.strong, null, React.createElement(_components.a, {
    href: "https://microsoft.github.io/data-science-editor-excel/hosted_files/data-science-editor-datasets.xlsx",
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "Getting Started DataSet Sheet")), " to get started with data"), "\n", React.createElement(_components.li, null, "Click ", React.createElement(_components.strong, null, "Get Addin"), " and search ", React.createElement(_components.strong, null, "Data Science Editor"), ", add this addin to your workspace."), "\n"), "\n", React.createElement(_components.h3, {
    id: "data-flows-through-blocks",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#data-flows-through-blocks",
    "aria-label": "data flows through blocks permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "\"Data flows through blocks\""), "\n", React.createElement(_components.p, null, "Each data blocks holds a dataset and acts as a transformation pipeline to the next block. The pipeline looks as follows:"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "a data block receives an updated dataset from its predecessor"), "\n", React.createElement(_components.li, null, "(optionally) the data block transforms the dataset. For example, it can sort the data according to a column."), "\n", React.createElement(_components.li, null, "(optionally) update charts or tables"), "\n", React.createElement(_components.li, null, "the data block pushes the data to its successors"), "\n"), "\n", React.createElement(_components.p, null, React.createElement(_components.img, {
    src: "/data-science-editor/static/story-95ebe306717c898fa3ff6c5aa13eb352.png",
    alt: "A data analysis program"
  })), "\n", React.createElement(_components.h3, {
    id: "-data-preview",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#-data-preview",
    "aria-label": " data preview permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "👀 Data preview"), "\n", React.createElement(_components.p, null, "The data blocks have a data preview button 👀 that allows to quickly glance at the dataset attached to the block. If a block also transforms the dataset, a before/after view is provided."), "\n", React.createElement(_components.p, null, React.createElement(_components.img, {
    src: "/data-science-editor/static/preview-584b98370cef9fe9cff1a01b9d42147e.png",
    alt: "Previewing data in a block"
  })), "\n", React.createElement(_components.h3, {
    id: "charts-on-the-fly",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#charts-on-the-fly",
    "aria-label": "charts on the fly permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Charts on the fly"), "\n", React.createElement(_components.p, null, "Add charts as you transform the data."), "\n", React.createElement(_components.p, null, React.createElement(_components.img, {
    src: "/data-science-editor/static/chart-db0e953473c5aaee7659e2e92787605a.png",
    alt: "A block with charts"
  })), "\n", React.createElement(_components.h3, {
    id: "discover-transforms",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#discover-transforms",
    "aria-label": "discover transforms permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Discover transforms"), "\n", React.createElement(_components.p, null, "Blocks are great to discover the vocabulary of a language. This also applies with data science."), "\n", React.createElement(_components.p, null, React.createElement(_components.img, {
    src: "/data-science-editor/static/discover-82e4f0a7235e8632e1166139b7912dbd.png",
    alt: "A block category"
  })), "\n", React.createElement(_components.h3, {
    id: "loading-and-saving-projects",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#loading-and-saving-projects",
    "aria-label": "loading and saving projects permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Loading and Saving projects"), "\n", React.createElement(_components.p, null, "The blocks are automatically saved in the worksheet."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
